import { memoize } from "lodash-es";
import { rangeOf } from "utils/arrays";

const [full, empty] = [100, 0];

export const getStars = memoize((value, numberOfStars) => {
  const whole = Math.trunc(value);

  const stars = rangeOf(numberOfStars)
    .map(position => {
      if(position <= whole)
        return full;
      
      if(position > whole + 1)
        return empty;  

      const fraction = value - whole;
      return Math.round(fraction * 100);
    });

  return stars;
});